import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import VisibilitySensor from "react-visibility-sensor";
import {
  getContent,
  getDelayedIndexBasedAnimationTime,
  getRightContent,
  getVisibleSensorAnimation,
} from "../assets/js/utils";
import CardHover from "./CardHover";
import ContentTitle from "./ContentTitle";
import useWindowSize from "./hooks/useWindowSize";
import Note from "./Note";
import SimpleMedia from "./SimpleMedia";

import financialHighlightsIcon1 from "../assets/images/financial-high-1.svg";
import financialHighlightsIcon2 from "../assets/images/financial-high-2.svg";
import financialHighlightsIcon3 from "../assets/images/financial-high-3.svg";
import financialHighlightsIcon4 from "../assets/images/financial-high-4.svg";
import financialHighlightsIcon5 from "../assets/images/financial-high-5.svg";
import financialHighlightsIcon6 from "../assets/images/financial-high-6.svg";

import ProgressBar from "./ProgressBar";
import useKeyPropRtlLanguage from "./hooks/useKeyPropRtlLanguage";

const financialHighlightsIcons = [
  financialHighlightsIcon1,
  financialHighlightsIcon2,
  financialHighlightsIcon3,
  financialHighlightsIcon4,
  financialHighlightsIcon5,
  financialHighlightsIcon6,
];

function Content1(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);
  const windowWidth = useWindowSize();
  const keyAnimationRestartWhenChangeLanguage = useKeyPropRtlLanguage();

  return (
    <div key={keyAnimationRestartWhenChangeLanguage}>
      <div className="general-m">
        <ContentTitle
          label={getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content.title
          )}
        />

        <div className="general-separator"></div>
      </div>
      <div className="general-m-just-wide-screen">
        <Note
          title={getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content
              .operationalHighlights.title
          )}
          components={getContent().sections[
            sections.currentSection
          ].content.operationalHighlights.components.map((component, index) => (
            <SimpleMedia
              key={index}
              counterValue={component.counterValue}
              topText={getRightContent(
                generalSettings.rtlLanguage,
                component.topText || ["", ""]
              )}
              bottomText={getRightContent(
                generalSettings.rtlLanguage,
                component.bottomText
              )}
              suffix={getRightContent(
                generalSettings.rtlLanguage,
                component.suffix || ["", ""]
              )}
              delay={getDelayedIndexBasedAnimationTime(
                windowWidth,
                index,
                0.25,
                1.1
              )}
            />
          ))}
        />
      </div>

      <div className="general-m">
        <div className="general-separator"></div>
        <h2 className="note__title">
          {getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content
              .financialHighlights.title
          )}
        </h2>
        <div className="content1__cards-container">
          {getContent().sections[
            sections.currentSection
          ].content.financialHighlights.cards.map((card, index) => (
            <VisibilitySensor partialVisibility key={index}>
              {({ isVisible }) => (
                <div
                  className="content1__card-item"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `fade-in-20vh 1s ${getDelayedIndexBasedAnimationTime(
                      windowWidth,
                      index
                    )}s backwards`
                  )}
                >
                  <CardHover
                    title={getRightContent(
                      generalSettings.rtlLanguage,
                      card.title
                    )}
                    icon={financialHighlightsIcons[index]}
                    components={card.components.map((component, compIndex) => (
                      <div
                        key={compIndex}
                        className="content1__card-bottom-container"
                      >
                        <div className="content1__card-year">
                          {component.year}
                        </div>
                        <SimpleMedia
                          counterValue={component.counterValue}
                          bottomText={getRightContent(
                            generalSettings.rtlLanguage,
                            component.bottomText
                          )}
                          applyBottomTextClassName="color-dark font-size-6"
                        />
                      </div>
                    ))}
                  />
                </div>
              )}
            </VisibilitySensor>
          ))}
        </div>

        <div className="general-separator"></div>

        <div className="general-m">
          <h2 className="note__title">
            {getRightContent(
              generalSettings.rtlLanguage,
              getContent().sections[sections.currentSection].content
                .revenueSegmentation.title
            )}
          </h2>
          <div className="content1__progressBar-container">
            {getContent().sections[
              sections.currentSection
            ].content.revenueSegmentation.circleProgressBars.map(
              (circleProgressBar, index) => (
                <VisibilitySensor partialVisibility key={index}>
                  {({ isVisible }) => (
                    <div
                      className="content1__progressBar-item"
                      style={getVisibleSensorAnimation(
                        isVisible,
                        `fade-in-20vh 1s ${getDelayedIndexBasedAnimationTime(
                          windowWidth,
                          index
                        )}s backwards`
                      )}
                    >
                      <ProgressBar
                        percentage={circleProgressBar.percentage}
                        speed={circleProgressBar.speed}
                        delay={1000}
                        isVisible={isVisible}
                        label={getRightContent(
                          generalSettings.rtlLanguage,
                          circleProgressBar.label
                        )}
                        strokeColor={circleProgressBar.strokeColor}
                        rtl={generalSettings.rtlLanguage}
                      />
                    </div>
                  )}
                </VisibilitySensor>
              )
            )}
          </div>
        </div>
        <div className="general-separator"></div>
        <div className="general-separator"></div>
      </div>
    </div>
  );
}

export default Content1;
